/* eslint-disable no-confusing-arrow */
/* eslint-disable react/destructuring-assignment */
import 'moment/locale/pt-br';

import {
  EnvironmentOutlined,
  PhoneOutlined,
  PlusCircleOutlined,
  PrinterOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { Button, Col, Input, Row, Tag } from 'antd';
import moment from 'moment';
import React from 'react';

import {
  PopoverFixed as Popover,
  TooltipFixed as Tooltip,
} from '../../components/FixedFullScreen';
import { accentTrim } from '../../helpers/accentTrim';
import {
  formatarMilhar,
  formatarMoedaIMask,
  formatarPorcentagem,
} from '../../helpers/formatador';
import { AuthConsumer } from '../../security/authContext';
import Can from '../../security/Can';
import {
  validaChildren,
  validaDateToday,
  validaIntegracao,
} from './LocalizacaoMotorista/utils/validaLocalizacao';
import { Texto } from './styles';

const getTimeFilter = formRef => formRef.current.getFieldValue('periodo');

const textFilter = (value, record) => {
  const r = record === null ? '' : 0;
  if (!value.length || !r.toString().length) {
    return false;
  }

  const filter = record;

  if (filter) {
    return accentTrim(filter.toString().toLowerCase()).includes(
      accentTrim(value.toString().toLowerCase())
    );
  }
};

const sortTable = (a, b) => {
  if (typeof a === 'number') {
    return a - b;
  }

  if (a) {
    return a.localeCompare(b);
  }
};

const getColumnSearchProps = searchInput => ({
  // eslint-disable-next-line react/prop-types
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          // eslint-disable-next-line no-param-reassign
          searchInput = node;
        }}
        value={selectedKeys[0]}
        onChange={e => {
          setSelectedKeys(e.target.value ? [e.target.value] : []);
        }}
        onPressEnter={() => {
          confirm();
        }}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => {
          confirm();
        }}
        icon={<SearchOutlined />}
        style={{ marginRight: 5 }}
      >
        Pesquisar
      </Button>
      <Button
        onClick={() => {
          clearFilters();
        }}
      >
        Limpar
      </Button>
    </div>
  ),
  filterIcon: filtered => (
    <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
  ),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => searchInput.select());
    }
  },
});

export const getColumns = (
  headerDataTable,
  filteredInfo,
  formRef,
  searchInput,
  onClickOrigem,
  onClickDestino,
  onClickLocalizacao,
  onClickDadosMotorista,
  onClickAbrirCte,
  onClickAbrirOrdemCarregamento
) => {
  let colunas = [
    {
      title: (
        <Tooltip placement="topLeft" title="Cadência">
          Cad.
        </Tooltip>
      ),
      dataIndex: ['cadencia'],
      key: 'cadencia',
      align: 'center',
      filteredValue: filteredInfo.cadencia || null,
      ...getColumnSearchProps(searchInput),
      onFilter: (value, r) => textFilter(value, r.cadencia),
      sorter: (a, b) => sortTable(a.cadencia, b.cadencia),
      showSorterTooltip: false,
      render: text => text,
      width: 70,
    },

    {
      title: (
        <Tooltip placement="topLeft" title="Embarcado">
          Emb.
        </Tooltip>
      ),
      dataIndex: ['embarcado'],
      key: 'embarcado',
      align: 'center',
      filteredValue: filteredInfo.embarcado || null,
      ...getColumnSearchProps(searchInput),
      onFilter: (value, r) =>
        textFilter(
          value,
          `${r.embarcado} (${r.qtd_peso_total_carregado_hoje.toFixed(2)}T)`
        ),
      sorter: (a, b) => sortTable(a.embarcado, b.embarcado),
      showSorterTooltip: false,
      render: (text, record) =>
        `${formatarMilhar(text, 0, false)} (${formatarMilhar(
          record.qtd_peso_total_carregado_hoje
        )}T)`,
      width: 70,
    },

    {
      title: (
        <Tooltip placement="topLeft" title="Fila">
          Fila
        </Tooltip>
      ),
      dataIndex: ['fila'],
      key: 'fila',
      align: 'center',
      filteredValue: filteredInfo.fila || null,
      ...getColumnSearchProps(searchInput),
      onFilter: (value, r) =>
        textFilter(
          value,
          `${r.fila} (${r.qtd_peso_total_fila_hoje.toFixed(2)}T)`
        ),
      sorter: (a, b) => sortTable(a.fila, b.fila),
      showSorterTooltip: false,
      render: (text, record) =>
        `${formatarMilhar(text, 0, false)} (${formatarMilhar(
          record.qtd_peso_total_fila_hoje
        )}T)`,
      width: 70,
    },

    {
      title: (
        <Tooltip placement="topLeft" title="Trânsito">
          Trân.
        </Tooltip>
      ),
      dataIndex: ['transito'],
      key: 'transito',
      align: 'center',
      filteredValue: filteredInfo.transito || null,
      ...getColumnSearchProps(searchInput),
      onFilter: (value, r) =>
        textFilter(
          value,
          `${r.transito} (${r.qtd_peso_total_transito_hoje.toFixed(2)}T)`
        ),
      sorter: (a, b) => sortTable(a.transito, b.transito),
      showSorterTooltip: false,
      render: (text, record) =>
        `${formatarMilhar(text, 0, false)} (${formatarMilhar(
          record.qtd_peso_total_transito_hoje
        )}T)`,
      width: 90,
    },

    {
      title: (
        <Tooltip placement="topLeft" title="Aguardando Aprovação">
          A. Apro.
        </Tooltip>
      ),
      dataIndex: ['aguardando_aprovacao'],
      key: 'aguardando_aprovacao',
      align: 'center',
      filteredValue: filteredInfo.aguardando_aprovacao || null,
      ...getColumnSearchProps(searchInput),
      onFilter: (value, r) =>
        textFilter(
          value,
          `${
            r.aguardando_aprovacao
          } (${r.qtd_peso_total_aguardando_aprovacao_hoje.toFixed(2)}T)`
        ),
      sorter: (a, b) =>
        sortTable(a.aguardando_aprovacao, b.aguardando_aprovacao),
      showSorterTooltip: false,
      render: (text, record) =>
        `${formatarMilhar(text, 0, false)} (${formatarMilhar(
          record.qtd_peso_total_aguardando_aprovacao_hoje
        )}T)`,
      width: 90,
    },

    {
      title: (
        <Popover
          content={
            <>
              <p>Cálculo realizado:</p>
              <p>
                <em>Cadência - (Embarcado + Fila + Trânsito)</em>
              </p>
            </>
          }
          title="Falta Agênciar"
          trigger="hover"
        >
          Falt. Agen.
        </Popover>
      ),
      dataIndex: ['falta_agenciar'],
      key: 'falta_agenciar',
      align: 'center',
      filteredValue: filteredInfo.falta_agenciar || null,
      ...getColumnSearchProps(searchInput),
      onFilter: (value, r) => textFilter(value, r.falta_agenciar),
      sorter: (a, b) => sortTable(a.falta_agenciar, b.falta_agenciar),
      showSorterTooltip: false,
      render: text => text || '0',
      width: 100,
    },

    {
      title: (
        <Popover
          content={
            <>
              <p>Cálculo realizado:</p>
              <p>
                <em>(Embarcado + Fila + Trânsito) / Cadência * 100</em>
              </p>
            </>
          }
          title="Aderência"
          trigger="hover"
        >
          Ader.
        </Popover>
      ),
      dataIndex: ['aderencia'],
      key: 'aderencia',
      align: 'center',
      filteredValue: filteredInfo.aderencia || null,
      ...getColumnSearchProps(searchInput),
      onFilter: (value, r) => textFilter(value, r.aderencia),
      sorter: (a, b) => sortTable(a.aderencia, b.aderencia),
      showSorterTooltip: false,
      render: text => `${text ? formatarPorcentagem(text) : '0,00 %'}`,
      width: 70,
    },
    {
      title: (
        <Popover
          content={
            <>
              <p>Cálculo realizado:</p>
              <p>
                <em>(Embarcado / Cadência) * 100</em>
              </p>
            </>
          }
          title="Carregado"
          trigger="hover"
        >
          Carr.
        </Popover>
      ),
      dataIndex: ['carregado_hoje'],
      key: 'carregado_hoje',
      align: 'center',
      filteredValue: filteredInfo.carregado_hoje || null,
      ...getColumnSearchProps(searchInput),
      onFilter: (value, r) => textFilter(value, r.carregado_hoje),
      sorter: (a, b) => sortTable(a.carregado_hoje, b.carregado_hoje),
      showSorterTooltip: false,
      render: text => `${text ? formatarPorcentagem(text) : '0,00 %'}`,
      width: 80,
    },
  ];

  /**
   * Tabela: Estado
   */
  if (headerDataTable === 'estado') {
    colunas = [
      {
        title: (
          <Tooltip placement="topLeft" title="Estado">
            Estado
          </Tooltip>
        ),
        dataIndex: ['_id', 'estado_cliente'],
        key: 'estado_cliente',
        align: 'center',
        filteredValue: filteredInfo.estado_cliente || null,
        ...getColumnSearchProps(searchInput),
        onFilter: (value, r) => textFilter(value, r._id.estado_cliente),
        sorter: (a, b) => sortTable(a._id.estado_cliente, b._id.estado_cliente),
        showSorterTooltip: false,
        render: text => text,
        width: 100,
      },
      ...colunas,
      {
        title: (
          <Tooltip placement="topLeft" title="Quantidade de lotes">
            Qtd. lotes
          </Tooltip>
        ),
        dataIndex: ['quantidade_lotes'],
        key: 'quantidade_lotes',
        align: 'center',
        filteredValue: filteredInfo.quantidade_lotes || null,
        ...getColumnSearchProps(searchInput),
        onFilter: (value, r) => textFilter(value, r.quantidade_lotes),
        sorter: (a, b) => sortTable(a.quantidade_lotes, b.quantidade_lotes),
        showSorterTooltip: false,
        render: text => text || '0',
        width: 100,
      },
    ];

    /**
     * Tabela: Lote
     */
  } else if (headerDataTable === 'lotes') {
    colunas = [
      {
        title: (
          <Tooltip placement="topLeft" title="Cidade Origem">
            Origem
          </Tooltip>
        ),
        ellipsis: true,
        dataIndex: ['cidade_origem'],
        key: 'cidade_origem',
        align: 'center',
        filteredValue: filteredInfo.cidade_origem || null,
        className: 'td-origem-destino',
        ...getColumnSearchProps(searchInput),
        onFilter: (value, r) =>
          textFilter(
            value,
            r.cidade_expedidor || r.cidade_remetente || r.cidade_origem
          ),
        sorter: (a, b) => sortTable(a.cidade_origem, b.cidade_origem),
        showSorterTooltip: false,
        render: (text, record) => (
          <div
            className="click-modal"
            tabIndex="0"
            role="button"
            onKeyDown={e => {
              e.stopPropagation();
              onClickOrigem(record);
            }}
            onClick={e => {
              e.stopPropagation();
              onClickOrigem(record);
            }}
          >
            <PlusCircleOutlined style={{ marginRight: '5px' }} />
            {`${record.cidade_expedidor ||
              record.cidade_remetente ||
              (text && text.toUpperCase())}`}
          </div>
        ),
        width: 115,
      },
      {
        title: (
          <Tooltip placement="topLeft" title="Cidade Destino">
            Destino
          </Tooltip>
        ),
        ellipsis: true,
        dataIndex: ['cidade_destino'],
        key: 'cidade_destino',
        align: 'center',
        filteredValue: filteredInfo.cidade_destino || null,
        className: 'td-origem-destino',
        ...getColumnSearchProps(searchInput),
        onFilter: (value, r) =>
          textFilter(
            value,
            r.cidade_recebedor || r.cidade_destinatario || r.cidade_destino
          ),
        sorter: (a, b) => sortTable(a.cidade_destino, b.cidade_destino),
        showSorterTooltip: false,
        render: (text, record) => (
          <div
            className="click-modal"
            tabIndex="0"
            role="button"
            onKeyDown={e => {
              e.stopPropagation();
              onClickDestino(record);
            }}
            onClick={e => {
              e.stopPropagation();
              onClickDestino(record);
            }}
          >
            <PlusCircleOutlined style={{ marginRight: '5px' }} />
            {`${record.cidade_recebedor ||
              record.cidade_destinatario ||
              (text && text.toUpperCase())}`}
          </div>
        ),
        width: 115,
      },
      {
        title: (
          <Tooltip placement="topLeft" title="Transportadora">
            Transp.
          </Tooltip>
        ),
        ellipsis: true,
        dataIndex: ['nome_transportadora'],
        key: 'nome_transportadora',
        align: 'center',
        filteredValue: filteredInfo.nome_transportadora || null,
        ...getColumnSearchProps(searchInput),
        onFilter: (value, r) => textFilter(value, r.nome_transportadora),
        sorter: (a, b) =>
          sortTable(a.nome_transportadora, b.nome_transportadora),
        showSorterTooltip: false,
        render: text => <Texto>{text || 'TMOV'}</Texto>,
        width: 105,
      },
      {
        title: (
          <Tooltip placement="topLeft" title="Produto">
            Prod.
          </Tooltip>
        ),
        ellipsis: true,
        dataIndex: ['produto'],
        key: 'produto',
        align: 'center',
        filteredValue: filteredInfo.produto || null,
        ...getColumnSearchProps(searchInput),
        onFilter: (value, r) => textFilter(value, r.produto),
        sorter: (a, b) => sortTable(a.produto, b.produto),
        showSorterTooltip: false,
        render: text => text,
        width: 105,
      },
      ...colunas,
      {
        title: (
          <Tooltip placement="topLeft" title="Valor Frete Empresa">
            F.Empresa
          </Tooltip>
        ),
        dataIndex: ['valor_empresa'],
        key: 'valor_empresa',
        align: 'center',
        filteredValue: filteredInfo.valor_empresa || null,
        ...getColumnSearchProps(searchInput),
        onFilter: (value, r) => textFilter(value, r.valor_empresa),
        sorter: (a, b) => sortTable(a.valor_empresa, b.valor_empresa),
        showSorterTooltip: false,
        render: (value, record) => {
          const valorEmpresa = formatarMoedaIMask(record.valor_empresa) || '-';
          return `${valorEmpresa}`;
        },
        width: 90,
      },
      {
        title: (
          <Tooltip placement="topLeft" title="Status lote">
            St. Lote
          </Tooltip>
        ),
        dataIndex: ['status_lote'],
        key: 'status_lote',
        filters: [
          { text: 'Carregando', value: 'Carregando' },
          { text: 'Suspenso', value: 'Suspenso' },
          { text: 'Finalizado', value: 'Finalizado' },
          { text: 'Encerrado', value: 'Encerrado' },
        ],
        filteredValue: filteredInfo.status_lote || null,
        align: 'center',
        onFilter: (value, r) => r.status_lote && r.status_lote.includes(value),
        sorter: (a, b) => sortTable(a.status_lote, b.status_lote),
        showSorterTooltip: false,
        ellipsis: true,
        render: text => {
          let color = null;
          switch (text) {
            case 'Carregando':
              color = 'geekblue';
              break;
            case 'Suspenso':
              color = 'volcano';
              break;
            case 'Finalizado':
              color = 'green';
              break;
            default:
              break;
          }

          return (
            <Tag color={color} key={text}>
              {text}
            </Tag>
          );
        },
        width: 100,
      },
    ];

    /**
     * Tabela: Motorista
     */
  } else if (headerDataTable === 'motorista') {
    colunas = [
      {
        title: (
          <Tooltip placement="topLeft" title="Motorista">
            Motorista
          </Tooltip>
        ),
        ellipsis: true,
        dataIndex: ['motorista'],
        key: 'motorista',
        align: 'left',
        filteredValue: filteredInfo.motorista || null,
        ...getColumnSearchProps(searchInput),
        onFilter: (value, r) => textFilter(value, r.motorista),
        sorter: (a, b) => sortTable(a.motorista, b.motorista),
        showSorterTooltip: false,
        render: text => text,
        width: 120,
      },
      {
        title: (
          <Tooltip placement="topLeft" title="Placa">
            Placa
          </Tooltip>
        ),
        dataIndex: ['placa'],
        key: 'placa',
        align: 'center',
        filteredValue: filteredInfo.placa || null,
        ...getColumnSearchProps(searchInput),
        onFilter: (value, r) => textFilter(value, r.placa),
        sorter: (a, b) => sortTable(a.placa, b.placa),
        showSorterTooltip: false,
        render: (text, record) => (
          <AuthConsumer>
            {({ user }) => (
              <Row>
                <Can
                  profile={user.profile}
                  permissions={user.permissions}
                  perform="painel-embarque:tracking"
                  no={() => <span>{text && text.toUpperCase()}</span>}
                  yes={() => (
                    <Col
                      className="td-placa"
                      tabIndex="0"
                      role="button"
                      onKeyDown={event => event.stopPropagation()}
                      onClick={event => onClickLocalizacao(event, record)}
                    >
                      {text && text.toUpperCase()}
                      {validaChildren(record.children) &&
                        validaIntegracao(record?._id?.id_lote_conjunto) &&
                        validaDateToday(record, getTimeFilter(formRef)) && (
                          <EnvironmentOutlined style={{ marginLeft: '5px' }} />
                        )}
                    </Col>
                  )}
                />
                <Can
                  profile={user.profile}
                  permissions={user.permissions}
                  perform="painel-embarque:contato"
                  yes={() => (
                    <Col
                      className="td-placa"
                      tabIndex="0"
                      role="button"
                      onKeyDown={event => event.stopPropagation()}
                      onClick={event => onClickDadosMotorista(event, record)}
                    >
                      {validaChildren(record.children) && (
                        <PhoneOutlined style={{ marginLeft: '5px' }} />
                      )}
                    </Col>
                  )}
                />
              </Row>
            )}
          </AuthConsumer>
        ),
        width: 100,
      },
      {
        title: (
          <Tooltip placement="topLeft" title="Peso">
            Peso
          </Tooltip>
        ),
        dataIndex: ['peso'],
        key: 'peso',
        align: 'center',
        filteredValue: filteredInfo.peso || null,
        ...getColumnSearchProps(searchInput),
        onFilter: (value, r) => textFilter(value, r.peso),
        sorter: (a, b) => sortTable(a.peso, b.peso),
        showSorterTooltip: false,
        render: text => `${formatarMilhar(text)}T`,
        width: 90,
      },
      {
        title: (
          <>
            <Tooltip placement="topLeft" title="Número CT-e">
              Núm. CT-e
            </Tooltip>
          </>
        ),
        dataIndex: ['numero_cte'],
        key: 'numero_cte',
        align: 'center',
        filteredValue: filteredInfo.numero_cte || null,
        ...getColumnSearchProps(searchInput),
        onFilter: (value, r) => textFilter(value, r.numero_cte),
        sorter: (a, b) => sortTable(a.numero_cte, b.numero_cte),
        showSorterTooltip: false,
        render: (text, record) =>
          text && (
            <div>
              {text}
              {text !== '-' && (
                <Button type="text" onClick={() => onClickAbrirCte(record)}>
                  <PrinterOutlined />
                </Button>
              )}
            </div>
          ),
        width: 115,
      },
      {
        title: (
          <Tooltip placement="topLeft" title="Valor Frete Empresa">
            F.Empresa
          </Tooltip>
        ),
        dataIndex: ['valor_empresa'],
        key: 'valor_empresa',
        align: 'center',
        filteredValue: filteredInfo.valor_empresa || null,
        ...getColumnSearchProps(searchInput),
        onFilter: (value, r) => textFilter(value, r.valor_empresa),
        sorter: (a, b) => sortTable(a.valor_empresa, b.valor_empresa),
        showSorterTooltip: false,
        render: (text, record) => {
          const valorEmpresa = formatarMoedaIMask(record.valor_empresa) || '-';
          return `${valorEmpresa}`;
        },
        width: 105,
      },
      {
        title: (
          <Tooltip placement="topLeft" title="Ordem de Carregamento">
            O.C.
          </Tooltip>
        ),
        dataIndex: ['ordem_carregamento'],
        key: 'ordem_carregamento',
        align: 'center',
        filteredValue: filteredInfo.ordem_carregamento || null,
        ...getColumnSearchProps(searchInput),
        onFilter: (value, r) => textFilter(value, r.ordem_carregamento),
        sorter: (a, b) => sortTable(a.ordem_carregamento, b.ordem_carregamento),
        showSorterTooltip: false,
        render: (text, record) => (
          <div>
            <Button
              type="text"
              onClick={() => onClickAbrirOrdemCarregamento(record)}
            >
              <PrinterOutlined />
            </Button>
          </div>
        ),
        width: 90,
      },
      {
        title: (
          <Tooltip placement="topLeft" title="Data ação">
            Dt. ação
          </Tooltip>
        ),
        dataIndex: ['data_acao'],
        key: 'data_acao',
        align: 'center',
        filteredValue: filteredInfo.data_acao || null,
        ...getColumnSearchProps(searchInput),
        onFilter: (value, r) => textFilter(value, r.data_acao),
        sorter: (a, b) => sortTable(a.data_acao, b.data_acao),
        showSorterTooltip: false,
        render: text =>
          moment(text, 'DD/MM/YYYY HH:mm').isValid()
            ? text
            : moment(new Date(text))
                .add(3, 'hours')
                .format('DD/MM/YYYY HH:mm'),
        width: 95,
      },
      {
        title: (
          <Tooltip placement="topLeft" title="Status da Placa">
            Status
          </Tooltip>
        ),
        dataIndex: ['status_lote_conjunto'],
        key: 'status_lote_conjunto',
        filters: [
          { text: 'Em Trânsito', value: 'Em Trânsito' },
          { text: 'Na Fila', value: 'Na Fila' },
          { text: 'Embarcado', value: 'Embarcado' },
        ],
        filteredValue: filteredInfo.status_lote_conjunto || null,
        onFilter: (value, record) =>
          record.status_lote_conjunto &&
          record.status_lote_conjunto.includes(value),
        filterMultiple: true,
        sorter: (a, b) =>
          sortTable(a.status_lote_conjunto, b.status_lote_conjunto),
        showSorterTooltip: false,
        align: 'center',
        render: text => {
          let color = null;
          switch (text) {
            case 'Em Trânsito':
              color = 'geekblue';
              break;
            case 'Na Fila':
              color = 'volcano';
              break;
            case 'Embarcado':
              color = 'green';
              break;
            default:
              break;
          }

          return (
            <Tag color={color} key={text}>
              {text}
            </Tag>
          );
        },
        width: 105,
      },
    ];
  }

  return colunas;
};
